export default __webpack_public_path__ + "static/media/icon-list.57adc6cb.svg";